import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
export function useForgotPasswordState() {
    const navigate = useNavigate();
    const { formState: { errors, isValid }, handleSubmit: submitForm, register, } = useForm({
        mode: "all",
        defaultValues: {
            email: "",
            delivery_method: "email",
        },
    });
    const canSubmit = useMemo(() => !!isValid, [isValid]);
    const handleBackClicked = useCallback(() => {
        navigate(-1);
    }, []);
    return useMemo(() => ({
        canSubmit,
        errors,
        handleBackClicked,
        register,
        submitForm,
    }), [canSubmit, errors, handleBackClicked, register, submitForm]);
}
